/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListUserSessionFacetsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListUserSessionFacetsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListUserSessionFacetsSecurity = {
  option1?: ListUserSessionFacetsSecurityOption1 | undefined;
  option2?: ListUserSessionFacetsSecurityOption2 | undefined;
};

export type ListUserSessionFacetsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListUserSessionFacetsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListUserSessionFacetsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListUserSessionFacetsSecurityOption1$Outbound,
  ListUserSessionFacetsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listUserSessionFacetsSecurityOption1ToJSON(
  listUserSessionFacetsSecurityOption1: ListUserSessionFacetsSecurityOption1,
): string {
  return JSON.stringify(
    ListUserSessionFacetsSecurityOption1$outboundSchema.parse(
      listUserSessionFacetsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListUserSessionFacetsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListUserSessionFacetsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListUserSessionFacetsSecurityOption2$Outbound,
  ListUserSessionFacetsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listUserSessionFacetsSecurityOption2ToJSON(
  listUserSessionFacetsSecurityOption2: ListUserSessionFacetsSecurityOption2,
): string {
  return JSON.stringify(
    ListUserSessionFacetsSecurityOption2$outboundSchema.parse(
      listUserSessionFacetsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListUserSessionFacetsSecurity$Outbound = {
  Option1?: ListUserSessionFacetsSecurityOption1$Outbound | undefined;
  Option2?: ListUserSessionFacetsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListUserSessionFacetsSecurity$outboundSchema: z.ZodMiniType<
  ListUserSessionFacetsSecurity$Outbound,
  ListUserSessionFacetsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListUserSessionFacetsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListUserSessionFacetsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listUserSessionFacetsSecurityToJSON(
  listUserSessionFacetsSecurity: ListUserSessionFacetsSecurity,
): string {
  return JSON.stringify(
    ListUserSessionFacetsSecurity$outboundSchema.parse(
      listUserSessionFacetsSecurity,
    ),
  );
}

/** @internal */
export type ListUserSessionFacetsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListUserSessionFacetsRequest$outboundSchema: z.ZodMiniType<
  ListUserSessionFacetsRequest$Outbound,
  ListUserSessionFacetsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listUserSessionFacetsRequestToJSON(
  listUserSessionFacetsRequest: ListUserSessionFacetsRequest,
): string {
  return JSON.stringify(
    ListUserSessionFacetsRequest$outboundSchema.parse(
      listUserSessionFacetsRequest,
    ),
  );
}
